import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function BusinessIcon({ width = 24, height = 24, color = 'black' }) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <Path
        d="M10 2h4a2 2 0 012 2v2h4a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V8a2 2 0 012-2h4V4a2 2 0 012-2m4 4V4h-4v2h4m6 4H4v8h16v-8z"
        fill={color}
      />
    </Svg>
  );
}

export default BusinessIcon;
